import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgDustinLogo from '../../svg/dustin-logo.svg'
import { IconProps } from '../icon-props'

const DustinLogoIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgDustinLogo
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-dustinlogo', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default DustinLogoIcon
